module.exports = __webpack_public_path__ + "img/Icon_Historial_de_Citas_Over.7ec63c9b.svg";